import { render, staticRenderFns } from "./ManualDocuments.vue?vue&type=template&id=f5357980"
import script from "./ManualDocuments.vue?vue&type=script&lang=js"
export * from "./ManualDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports